import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../admin/AdminLogin.css';
import griffsoLogo from '../assets/griffso.png';

const API = 'https://ai.griffso.com/api/parsing';

const ClientLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (sessionStorage.getItem('client_token')) navigate('/parsingmodel/dashboard', { replace: true });
  }, [navigate]);

  useEffect(() => {
    setParticles(Array.from({ length: 50 }, (_, i) => ({
      id: i, x: Math.random() * 100, y: Math.random() * 100,
      size: Math.random() * 4 + 1, duration: Math.random() * 20 + 10, delay: Math.random() * 5,
    })));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.username || !form.password) { setError('All fields are required'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/client/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) {
        sessionStorage.setItem('client_token', data.token);
        sessionStorage.setItem('client_id', data.client_id);
        sessionStorage.setItem('client_name', data.name);
        navigate('/parsingmodel/dashboard');
      } else {
        setError(data.error?.msg || 'Invalid credentials');
      }
    } catch { setError('Server unreachable'); }
    setLoading(false);
  };

  return (
    <div className="admin-login-page">
      <div className="login-bg-gradient" />
      <div className="login-bg-mesh" />
      <div className="login-particles">
        {particles.map(p => (
          <div key={p.id} className="particle" style={{
            left: `${p.x}%`, top: `${p.y}%`, width: `${p.size}px`, height: `${p.size}px`,
            animationDuration: `${p.duration}s`, animationDelay: `${p.delay}s`,
          }} />
        ))}
      </div>
      <div className="login-orb login-orb-1" />
      <div className="login-orb login-orb-2" />
      <div className="login-orb login-orb-3" />
      <div className="login-center">
        <div className="login-glass-card">
          <div className="login-card-glow" />
          <div className="login-logo-area">
            <div className="login-logo-ring">
              <div className="login-logo-ring-inner">
                <img src={griffsoLogo} alt="Griffso" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
              </div>
            </div>
            <h1 className="login-title">Client Portal</h1>
            <p className="login-subtitle">Griffso Parsing Model — Dashboard Access</p>
          </div>
          <form className="login-form" onSubmit={handleSubmit}>
            {error && <div className="login-error"><span className="login-error-icon">⚠️</span><span>{error}</span></div>}
            <div className="login-field">
              <div className="login-field-icon">👤</div>
              <input type="text" placeholder="Username" value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })} className="login-input" autoComplete="username" />
              <div className="login-field-line" />
            </div>
            <div className="login-field">
              <div className="login-field-icon">🔒</div>
              <input type={showPassword ? 'text' : 'password'} placeholder="Password" value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })} className="login-input" autoComplete="current-password" />
              <button type="button" className="login-eye-btn" onClick={() => setShowPassword(!showPassword)} tabIndex={-1}>
                {showPassword ? '🙈' : '👁️'}
              </button>
              <div className="login-field-line" />
            </div>
            <button type="submit" className="login-submit-btn" disabled={loading}>
              {loading ? <div className="login-spinner" /> : <><span>Access Dashboard</span><span className="login-btn-arrow">→</span></>}
            </button>
          </form>
          <div className="login-footer-info">
            <div className="login-secure-badge"><span>🔐</span><span>Secure Client Access</span></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientLogin;
